
namespace GeniuzPOS.LogManage {

    @Serenity.Decorators.registerClass()
    export class LogRefundGrid extends Serenity.EntityGrid<LogRefundRow, any> {
        protected getColumnsKey() { return LogRefundColumns.columnsKey; }
        protected getDialogType() { return LogRefundDialog; }
        protected getIdProperty() { return LogRefundRow.idProperty; }
        protected getInsertPermission() { return LogRefundRow.insertPermission; }
        protected getLocalTextPrefix() { return LogRefundRow.localTextPrefix; }
        protected getService() { return LogRefundService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
        protected getButtons() {
			var button = super.getButtons();

            button.splice(Q.indexOf(button, x => x.cssClass == "add-button"), 1);
            
            button.push(Common.Helpers.ExcelExportHelper.createToolButton({
                grid: this,
                service: LogRefundService.baseUrl + '/ListExcel',
                onViewSubmit: () => this.onViewSubmit(),
                separator: true
            }));
                
                button.push(
                    {
                        title: Q.text("Close"), // *** Get button text from translation
                        cssClass: '.panel-titlebar-close',
                        icon: 'fa-close',
                        onClick: () => {
                            window.location.href = '/';
                            return false;
                        },
                    }
                );            
                
			// button.splice(Q.indexOf(button, x => x.cssClass == "add-button"), 1);
			return button;
		}
    }
}